import React from 'react';
import './Error.css';
import errorLogo from '../../images/itsy-404.png';


export default class Error extends React.Component
{
    state = {
        name: '',
    }

    handleChange = event =>
    {
        this.setState({language: event.target.value});
    };

    handleSubmit = event =>
    {
        event.preventDefault();
    }

    render()
    {
        return (
            <div align={'center'}>
                <img src={errorLogo} alt=""></img>
            </div>
        );
    }
}